import { ANALYTICS_CHART_TYPE } from "@resources/Constants";
import { Theme } from "@themes/Types";

const SingleDigitChartTypes = [
  ANALYTICS_CHART_TYPE.CROWD_COUNTING,
  ANALYTICS_CHART_TYPE.SHOPPING_CARTS_IN_USE
];

export function formatAnalyticsValue(value: number, chartType: string): string {
  const isCumulativeOrOccupancy =
    chartType.includes("CUMULATIVE") || chartType.includes("OCCUPANCY");

  if (isCumulativeOrOccupancy || SingleDigitChartTypes.includes(chartType)) {
    return Number(value?.toFixed(0)).toLocaleString();
  }

  return Number(value?.toFixed(1)).toLocaleString();
}

export const fixAnalyticsValue = (value: number, chartType: string): number => {
  const isCumulativeOrOccupancy =
    chartType.includes("CUMULATIVE") || chartType.includes("OCCUPANCY");

  if (isCumulativeOrOccupancy || SingleDigitChartTypes.includes(chartType)) {
    return Number(value?.toFixed(0));
  }

  return Number(value.toFixed(1));
};

export const prepareColumnObject = (
  header: string,
  accessorKey: string,
  size: number
) => ({
  header,
  accessorKey: `${accessorKey}.count`,
  size,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Cell: (props: { row: any }) =>
    props.row.original[accessorKey.toLowerCase()]?.value,
  mantineTableHeadCellProps: {
    style: { textAlign: "left" } as React.CSSProperties
  },
  mantineTableBodyCellProps: {
    style: { textAlign: "left" } as React.CSSProperties
  }
});

export const getColorByVehicleType = (theme: Theme, vehicle: string) => {
  if (vehicle === "car") {
    return theme.widget.stoppedVehicleStatistics.car;
  }
  if (vehicle === "truck") {
    return theme.widget.stoppedVehicleStatistics.truck;
  }
  if (vehicle === "bus") {
    return theme.widget.stoppedVehicleStatistics.bus;
  }
  if (vehicle === "motorcycle") {
    return theme.widget.stoppedVehicleStatistics.motorcycle;
  }
  if (vehicle === "bicycle") {
    return theme.widget.stoppedVehicleStatistics.bicycle;
  }

  return "";
};
